module.exports = __webpack_public_path__ + "static/media/learning-time-icon.7877af6a.svg";